function SortableHeader({ name, label, currentSort, onClick }) {
  const isAsc = currentSort === `${name} asc`
  const isDesc = currentSort === name

  const handleClick = () => {
    let nextSort
    if (isDesc) {
      nextSort = `${name} asc`
    } else if (isAsc) {
      nextSort = ""
    } else {
      nextSort = name
    }
    onClick(nextSort)
  }

  return (
    <th
      onClick={handleClick}
    >
      <div className="sortable-header-holder">
        <span>{label}</span>
        <span className="sortable-header-arrow-holder">
          <span className={isAsc ? "active" : ""}>
            ▲
          </span>
          <span className={isDesc ? "active" : ""}>
            ▼
          </span>
        </span>
      </div>
    </th>
  )
}

export default SortableHeader